// extracted by mini-css-extract-plugin
module.exports = {"filters":"FiltersReview_filters__jRLda"};